module.exports = __webpack_public_path__ + "static/tools_02-560x320-b09434f977d81b2695700d1395abce17.jpg";